module.exports = __webpack_public_path__ + "img/district_employees_data.2e204e92.png";